import { useCallback, useMemo, useState } from 'react';
import type { AuthSessionSnapshot } from '@/lib/common';
import { getRoleBasedOptimizationDefaults } from '@/screens/optimization/optimization-filter-defaults';
import {
  buildOptimizationQueryParams,
  type OptimizationFilterState,
} from '@/screens/optimization/types';

export function useOptimizationFilters(user: AuthSessionSnapshot | null) {
  const [filters, setFilters] = useState<OptimizationFilterState>(() =>
    getRoleBasedOptimizationDefaults(user),
  );

  const queryParams = useMemo(
    () => buildOptimizationQueryParams(filters),
    [filters],
  );

  const setScopeFilter = useCallback(
    (scopeFilter: OptimizationFilterState['scopeFilter']) => {
      setFilters((prev) => ({ ...prev, scopeFilter }));
    },
    [],
  );

  return {
    filters,
    setFilters,
    queryParams,
    setScopeFilter,
  };
}
